import React from 'react'

const SwitchAccount = () => {
  return (
    <div>SwitchAccount</div>
  )
}

export default SwitchAccount